<template>
    <section>
        <b-modal :id="modalId" :ref="modalId" size="xl" title="Pick Ticket" no-close-on-backdrop>
            <b-row class="mt-2">
                <b-col>
                    <h6>
                        {{
                            isReceiving
                            ? 'Select and confirm inventory item to receive to warehouse. '
                            : 'Select and confirm inventory item to ship to the test house. '
                        }}

                    </h6>
                    <Grid
                        :key="gridKey"
                        :pageable="false"
                        :resizable="true"
                        :reorderable="true"
                        :sortable="false"
                        :row-height="25"
                        :data-items="itemData"
                        :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
                        class="grid mt-1">
                        <template v-slot:commands="{props}">
                            <td>
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-form-checkbox v-model="props.dataItem.selected" @input="updateKey" />
                                </div>
                            </td>
                        </template>
                        <template v-slot:formatSeparator="{props}">
                            <td>{{ commafy(props.dataItem[props.field]) }}</td>
                        </template>
                        <template v-slot:qtyToPull="{props}">
                            <td>
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-form-input type="number" v-model="props.dataItem.quantityToPull" :disabled="props.dataItem.isConfirmed" @input="onQtyInput(props.dataItem.quantityToPull, props.dataItem.id, props.dataItem.onHand)" />
                                </div>
                            </td>
                        </template>
                        <template v-slot:qtyReceived="{props}">
                            <td>
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-form-input type="number" v-model="props.dataItem.qtyReceived" :disabled="props.dataItem.isConfirmed" @input="onQtyInput(props.dataItem.qtyReceived, props.dataItem.id, props.dataItem.quantityToPull)" />
                                </div>
                            </td>
                        </template>
                        <template v-slot:confirm="{props}">
                            <td>
                                <div class="d-flex justify-content-center align-items-center" :disabled="!props.dataItem.selected">
                                    <b-button size="sm" :variant="props.dataItem.isConfirmed ? 'success' : 'info'" @click="onConfirmPickItem(props.dataItem)" :disabled="props.dataItem.isDisabled">
                                        <span v-if="props.dataItem.isConfirmed">
                                            <i class="fa fa-check-circle"></i> Confirmed
                                        </span>
                                        <span v-else>
                                            <i class="fa fa-info-circle"></i> Confirm
                                        </span>

                                    </b-button>
                                </div>
                            </td>
                        </template>
                    </Grid>
                </b-col>
            </b-row>
            <template slot="modal-footer">
                <b-button variant="primary" class="mr-auto"> Print</b-button>
                <b-button @click="closeModal">Cancel</b-button>
                <b-button variant="primary" @click="shipOrReceive" :disabled="isSaving || !isSelectedConfirmed">
                    <i v-if="isSavingOnly" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                    {{ isReceiving ? 'Receive to Warehouse' : 'Ship to Test House' }}
                </b-button>
            </template>
        </b-modal>
        <pick-list-confirmation
            :isReceiving="isReceiving"
            :modalId="pickItemConfirmationModalId"
            :pickLineItem="pickLineData"
            @onHide="updateKey" />
    </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { date } from '@/shared/filters';
import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import {shippingFields, receivingFields} from './fields'
import PickListConfirmation from '../PickListConfirmation';

export default {
    props: {
        sOScheduledObj: {
            type: Object,
            default: () => {}
        },
        pickTicketList: {
            type: Array,
            default: () => []
        },
        pickTicketListName: {
            type: String,
            default: 'pickTicketLinesList'
        },
        modalId: {
            type: String,
            default: 'pick-list-modal'
        },
        serviceOrderId: {
            type: [Number, String],
            default: 0
        },
        isReceiving: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PickListConfirmation
    },
    data: () => ({
        date,
        shippingFields,
        receivingFields,
        prepareColumnsData,
        gridId: GRID_ID.PICK_LIST_WO_GRID,
        inventoryItem: {},
        pickLineData: {},
        confirmingPickItem: {},
        isInvalidQtyToShip: false,
        isSaving: false,
        isSavingOnly: false,
        isSavingAndClose: false,
        gridKey:0,
        isSelectedConfirmed: false,
    }),
    computed: {
        ...mapGetters('account', ['gridSettingsById']),
        // ...mapGetters('inventory', ['allocationsList']),
        gridSettings() {
            return this.gridSettingsById(this.gridId);
        },
        scheduleObj() {
            return {
                ...this.sOScheduledObj,
                qtyToShip: (this.sOScheduledObj) ? this.sOScheduledObj.quantity : 0
            }
        },
        itemData() {
            var itemList = this.pickTicketList.map(line => ({
                ...line,
                selected: false,
                inventorySerialNumber: (line.inventorySerialNumber) ? line.inventorySerialNumber.map(sn => ({
                    ...sn,
                })) : []
            }));
            console.log(itemList, "Item List")

            return this.isReceiving
                ? itemList.map(line => ({ ...line,
                        qtyReceived: line.quantityPulled,
                        partNumberConfirmed: false,
                        manufacturerConfirmed: false,
                        quantityPulledConfirmed: false,
                        dateCodeConfirmed: false,
                        lotCodeConfirmed: false,
                        conditionConfirmed: false,
                        revisionConfirmed: false,
                        cooConfirmed: false, 
                        isConfirmed: false }))
                : itemList.map(line => ({ ...line, quantityToPull: line.onHand}));
        },
        pickItemConfirmationModalId() {
            return this.modalId + '-confirmation'
        },
        fields() {
            return this.isReceiving ? this.receivingFields : this.shippingFields;
        }
    },
    methods: {
        // ...mapActions('inventory', ['getAllocationsBySalesOrderLineId']),
        ...mapActions('pickTicket', [
            'getPickTicketLines',
            'savePickTicket'
        ]),
        ...mapActions('serviceOrders', ['shipInventoryForWo', 'receivingInventoryFromTesting']),
        onSelection(allocationId, isChecked) {
            let i = this.pickTicketList.findIndex(x => x.id == allocationId);

            if (i > -1) {
                this.pickTicketList[i].isDisabled = !isChecked;
            }
        },
        onConfirmPickItem(pickItem) {
            let QtyToPullError = false;
            if(!this.isReceiving && (pickItem.quantityToPull <= 0 || pickItem.quantityToPull > pickItem.onHand)){
              QtyToPullError = true;
            }

            if(this.isReceiving && (pickItem.qtyReceived <= 0 || pickItem.qtyReceived > pickItem.quantityPulled)){
                QtyToPullError = true;
            }

            if(QtyToPullError){
              let qtyToCompare = this.isReceiving ? pickItem.quantityPulled : pickItem.onHand
              let msg = this.isReceiving ? (pickItem.quantityToPull <= 0 ? 'The Qty To Pull must be greater than 0' : 'The Qty To Pull can not be more than ' + qtyToCompare) : (pickItem.qtyReceived <= 0 ? 'The Qty To Receive must be greater then 0' : 'The Qty To Pull can not be more then ' + qtyToCompare);
              // let msg = (pickItem.quantityToPull <= 0) ? 'The Qty To Pull must be greater then 0' : 'The Qty To Pull can not be more then ' + pickItem.onHand;
              this.openAlertBox({message: msg,
                title: 'Please Check',okVariant: 'success',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',});
            }else if (pickItem.selected && (pickItem.quantityToPull > 0 || pickItem.qtyReceived > 0)) {
                this.pickLineData = pickItem;
                this.$bvModal.show(this.pickItemConfirmationModalId);
            } else {
                this.openAlertBox({message: 'Please check the corresponding row and input quantity before confirming',
                    title: 'Check before confirm',okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',});

            }

        },
        updateKey() {
            this.gridKey += 1;
            const selected = this.itemData.filter(x => x.selected).length
            const confirmed = this.itemData.filter(x => x.isConfirmed).length;
            this.isSelectedConfirmed = selected > 0 ? selected == confirmed : false;
        },
        async shipOrReceive() {
            if (this.isSelectedConfirmed) {
                this.isSaving = this.isSavingOnly = true;
                if (this.isReceiving) {
                    const inventoryData= this.itemData.filter(x => x.selected && x.isConfirmed).map(x => ({
                        inventoryId: x.inventoryId,
                        quantity: x.qtyReceived
                    }));

                    const result = await this.receivingInventoryFromTesting({
                        serviceOrderId: this.serviceOrderId,
                        wOInventory: inventoryData
                    });

                    this.$emit('refreshData');

                    if (result.status == 200) {
                        this.$snotify.success(`Successfully received the work order.`);
                        let routeWO = this.$router.resolve({
                            name: 'serviceorders.edit',
                            params: { id:this.serviceOrderId },
                        });

                        window.open(routeWO.href, '_blank');
                    }

                } else {
                    const inventoryData= this.itemData.filter(x => x.selected && x.isConfirmed).map(x => ({
                        inventoryId: x.id,
                        purchaseOrderLineId: x.purchaseOrderLineId,
                        quantity: x.quantityToPull
                    }));

                    const result = await this.shipInventoryForWo({
                        serviceOrderId: this.serviceOrderId,
                        wOInventory: inventoryData
                    });

                    this.$emit('refreshData');

                    if (result.status == 200) {
                        this.$snotify.success(`Successfully shipped to work order.`);
                        let routeWO = this.$router.resolve({
                            name: 'serviceorders.edit',
                            params: { id:this.serviceOrderId },
                        });

                        window.open(routeWO.href, '_blank');
                    }
                }
                this.isSaving = this.isSavingOnly = true;
                this.$bvModal.hide(this.modalId);

            }
        },

        onQtyInput(qty, id, qtyToCompare) {
            const ndx = this.pickTicketList.findIndex(x => x.id == id);
            // if (ndx > -1) {
            //     this.pickTicketList[ndx].selected = (qty != '' && qty > 0);
            // }
            if(ndx > -1 && qty > 0 && qty <= qtyToCompare){
              this.pickTicketList[ndx].selected = (qty != '' && qty > 0);
            }
        },
        closeModal() {
            this.$bvModal.hide(this.modalId);
        },
        commafy(num, currency = "", decimal = 2) {
            try {
                if (num != null) {
                    if (currency != "") {
                        num = Number(num).toFixed(decimal);
                    }
                    var str = num.toString().split('.');
                    if (str[0].length >= 3) {
                        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                    }
                    if (str[1]) {
                        if (str[1].length < decimal) {
                        while (str[1].length < decimal) { str[1] = str[1] + "0"; }
                        } else if (str[1].length > decimal) {
                        str[1] = str[1].substring(0, decimal)
                        }
                    }
                    return currency + str.join('.');
                }
            } catch {
                return num;
            }
        }
    },
}
</script>

<style scoped>
table > tr > th {
    margin-right: 10px;
}

.is-invalid-qty-to-ship {
    border-color: red;
}

.is-invalid-qty-to-pull {
    border-color: red;
}
</style>
